












import { defineComponent, PropType } from '@nuxtjs/composition-api';
import useResponsive from '@shared/composables/useResponsive';
import { ISBAsset } from '@shared/types/storyblok';
import { BaseImage } from '@shared/ui';

export default defineComponent({
  name: 'ResponsiveImage',
  components: { BaseImage },
  props: {
    description: {
      type: String,
      required: true,
    },
    // eslint-disable-next-line vue/prop-name-casing
    mobile_image: {
      type: Object as PropType<ISBAsset>,
      default: () => null,
    },
    // eslint-disable-next-line vue/prop-name-casing
    desktop_image: {
      type: Object as PropType<ISBAsset>,
      required: true,
    },
  },
  setup() {
    const { isMobile } = useResponsive();
    return {
      isMobile,
    };
  },
  computed: {
    hasMobileImage(): boolean {
      return !!this.mobile_image?.filename;
    },
  },
});
